import { useState } from 'react';
import AppLayout from '@/components/feature/AppLayout';

const sectionColors = [
  { section: 'Política', color: '#C41230' },
  { section: 'Esportes', color: '#16A34A' },
  { section: 'Cultura', color: '#7C3AED' },
  { section: 'Economia', color: '#EA580C' },
  { section: 'Ciência', color: '#0891B2' },
  { section: 'Internacional', color: '#1D4ED8' },
];

const aiToggles = [
  { label: 'Geração automática de títulos', desc: 'IA sugere títulos alternativos para cada artigo', enabled: true },
  { label: 'Resumo automático', desc: 'Resumir artigos longos para caber no layout', enabled: true },
  { label: 'Classificação de seção', desc: 'Classificar artigos automaticamente por seção', enabled: false },
  { label: 'Sugestão de imagens', desc: 'Gerar imagens com IA quando não houver foto', enabled: true },
  { label: 'Geração automática de layout', desc: 'Criar layout de páginas automaticamente', enabled: false },
];

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState('marca');
  const [saved, setSaved] = useState(false);
  const [toggles, setToggles] = useState(aiToggles.map(t => t.enabled));

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  const tabs = [
    { id: 'marca', label: 'Marca & Identidade', icon: 'ri-palette-line' },
    { id: 'tipografia', label: 'Tipografia', icon: 'ri-text' },
    { id: 'secoes', label: 'Seções', icon: 'ri-price-tag-3-line' },
    { id: 'ia', label: 'Configurações de IA', icon: 'ri-robot-line' },
    { id: 'integracao', label: 'Integrações', icon: 'ri-plug-line' },
    { id: 'usuarios', label: 'Usuários', icon: 'ri-team-line' },
  ];

  const integrations = [
    { name: 'OpenAI GPT-4', desc: 'Processamento de texto e geração de conteúdo', status: 'conectado', icon: 'ri-robot-line' },
    { name: 'DALL·E 3', desc: 'Geração de imagens com IA', status: 'conectado', icon: 'ri-image-ai-line' },
    { name: 'Google Analytics', desc: 'Métricas de leitura digital', status: 'desconectado', icon: 'ri-bar-chart-line' },
    { name: 'WordPress API', desc: 'Publicação automática no site', status: 'desconectado', icon: 'ri-global-line' },
  ];

  const users = [
    { name: 'João Editor', email: 'joao@jardelcitypost.com', role: 'Editor-Chefe', avatar: 'JE', active: true },
    { name: 'Carlos Mendes', email: 'carlos@jardelcitypost.com', role: 'Jornalista', avatar: 'CM', active: true },
    { name: 'Fernanda Lima', email: 'fernanda@jardelcitypost.com', role: 'Jornalista', avatar: 'FL', active: true },
    { name: 'Ana Paula Rocha', email: 'ana@jardelcitypost.com', role: 'Diagramadora', avatar: 'AP', active: false },
    { name: 'Roberto Souza', email: 'roberto@jardelcitypost.com', role: 'Fotógrafo', avatar: 'RS', active: true },
  ];

  return (
    <AppLayout>
      <div className="p-6">
        {/* Page Header */}
        <div className="border-b-2 border-[#111111] pb-3 mb-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#C41230] mb-1">Jardel City Post — Administração</p>
              <h1 className="font-['Playfair_Display'] text-2xl font-bold text-[#111111]">Configurações do Sistema</h1>
            </div>
            <button
              onClick={handleSave}
              className={`flex items-center gap-2 px-5 py-2.5 text-xs font-bold uppercase tracking-widest cursor-pointer whitespace-nowrap transition-all border ${saved ? 'bg-[#16A34A] text-white border-[#16A34A]' : 'bg-[#111111] text-white border-[#111111] hover:bg-[#333333]'}`}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={saved ? 'ri-check-line' : 'ri-save-line'}></i>
              </div>
              {saved ? 'Salvo!' : 'Salvar Configurações'}
            </button>
          </div>
        </div>

        <div className="flex gap-6">
          {/* Sidebar Tabs */}
          <div className="w-52 flex-shrink-0">
            <div className="bg-white border border-[#E0E0E0]">
              <div className="border-b-2 border-[#111111] px-4 py-2.5">
                <p className="text-[10px] font-bold uppercase tracking-widest text-[#555555]">Navegação</p>
              </div>
              <div className="p-1">
                {tabs.map((t) => (
                  <button
                    key={t.id}
                    onClick={() => setActiveTab(t.id)}
                    className={`w-full flex items-center gap-3 px-3 py-2.5 text-xs transition-all cursor-pointer mb-0.5 text-left ${activeTab === t.id ? 'bg-[#111111] text-white font-bold' : 'text-[#444444] hover:bg-[#F5F5F5] font-medium'}`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className={`${t.icon} text-sm`}></i>
                    </div>
                    <span className="uppercase tracking-wide text-[10px]">{t.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Info Box */}
            <div className="mt-4 bg-[#111111] p-4">
              <p className="text-[10px] font-bold uppercase tracking-widest text-[#888888] mb-2">Versão do Sistema</p>
              <p className="text-sm font-bold text-white font-['Playfair_Display']">JCP Editorial v2.4</p>
              <p className="text-[10px] text-[#AAAAAA] mt-1 font-['Source_Serif_4']">Última atualização: 06/04/2026</p>
              <div className="mt-3 pt-3 border-t border-[#333333]">
                <p className="text-[10px] text-[#888888] uppercase tracking-widest">Licença</p>
                <p className="text-[11px] text-[#CCCCCC] font-['Source_Serif_4']">Enterprise — Ilimitado</p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">

            {/* MARCA */}
            {activeTab === 'marca' && (
              <div className="bg-white border border-[#E0E0E0]">
                <div className="border-b-2 border-[#111111] px-6 py-3">
                  <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Marca & Identidade Visual</h2>
                  <p className="text-[11px] text-[#777777] mt-0.5 font-['Source_Serif_4']">Configurações visuais do jornal</p>
                </div>
                <div className="p-6 space-y-5">
                  {/* Logo */}
                  <div className="flex items-center gap-5 p-4 border border-[#E0E0E0] bg-[#F8F8F8]">
                    <div className="w-16 h-16 border border-[#CCCCCC] bg-white flex items-center justify-center overflow-hidden">
                      <img src="https://static.readdy.ai/image/cb3f25066178f57a7b4ff6ec1e98d674/3adf4e78d4ccc80f9408185bfae7ead8.png" alt="Logo" className="w-full h-full object-contain" />
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-widest text-[#111111]">Logo Atual</p>
                      <p className="text-[11px] text-[#777777] font-['Source_Serif_4'] mt-0.5">Jardel City Post</p>
                      <button className="text-[10px] font-bold uppercase tracking-widest text-[#C41230] cursor-pointer hover:underline mt-1.5">Alterar logo</button>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-2">Nome do Jornal</label>
                      <input
                        defaultValue="Jardel City Post"
                        className="w-full px-3 py-2 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']"
                      />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-2">Slogan</label>
                      <input
                        defaultValue="40 anos de jornalismo de qualidade"
                        className="w-full px-3 py-2 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']"
                      />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-2">Cor Primária</label>
                      <div className="flex items-center gap-2">
                        <input type="color" defaultValue="#C41230" className="w-10 h-9 cursor-pointer border border-[#CCCCCC]" />
                        <input defaultValue="#C41230" className="flex-1 px-3 py-2 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']" />
                      </div>
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-2">Cor Secundária</label>
                      <div className="flex items-center gap-2">
                        <input type="color" defaultValue="#111111" className="w-10 h-9 cursor-pointer border border-[#CCCCCC]" />
                        <input defaultValue="#111111" className="flex-1 px-3 py-2 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']" />
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-2">Tagline Editorial</label>
                    <textarea
                      defaultValue="Cobrindo a cidade com rigor, profundidade e 40 anos de credibilidade jornalística."
                      rows={3}
                      className="w-full px-3 py-2 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4'] resize-none"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* TIPOGRAFIA */}
            {activeTab === 'tipografia' && (
              <div className="bg-white border border-[#E0E0E0]">
                <div className="border-b-2 border-[#111111] px-6 py-3">
                  <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Tipografia Editorial</h2>
                  <p className="text-[11px] text-[#777777] mt-0.5 font-['Source_Serif_4']">Fontes utilizadas no sistema e nas publicações</p>
                </div>
                <div className="p-6 space-y-4">
                  {[
                    { label: 'Fonte de Títulos', value: 'Playfair Display', desc: 'Manchetes e títulos de seção', preview: 'Jardel City Post — Jornalismo de Qualidade' },
                    { label: 'Fonte de Corpo', value: 'Source Serif 4', desc: 'Texto dos artigos e conteúdo editorial', preview: 'A cobertura jornalística de excelência começa com a escolha certa das palavras.' },
                    { label: 'Fonte de Interface', value: 'Inter', desc: 'Elementos de UI, botões e labels', preview: 'Dashboard · Conteúdo · IA · Layout · Exportar' },
                  ].map((f) => (
                    <div key={f.label} className="border border-[#E0E0E0]">
                      <div className="flex items-center justify-between px-4 py-3 border-b border-[#E0E0E0] bg-[#F8F8F8]">
                        <div>
                          <p className="text-xs font-bold uppercase tracking-widest text-[#111111]">{f.label}</p>
                          <p className="text-[11px] text-[#777777] font-['Source_Serif_4']">{f.desc}</p>
                        </div>
                        <select
                          defaultValue={f.value}
                          className="px-3 py-1.5 text-xs border border-[#CCCCCC] focus:outline-none focus:border-[#111111] cursor-pointer bg-white uppercase tracking-wide font-bold"
                        >
                          <option>Playfair Display</option>
                          <option>Source Serif 4</option>
                          <option>Merriweather</option>
                          <option>Georgia</option>
                          <option>Times New Roman</option>
                          <option>Inter</option>
                        </select>
                      </div>
                      <div className="px-4 py-4 bg-white">
                        <p className="text-xl text-[#111111]" style={{ fontFamily: f.value }}>{f.preview}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* SEÇÕES */}
            {activeTab === 'secoes' && (
              <div className="bg-white border border-[#E0E0E0]">
                <div className="border-b-2 border-[#111111] px-6 py-3 flex items-center justify-between">
                  <div>
                    <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Configuração de Seções</h2>
                    <p className="text-[11px] text-[#777777] mt-0.5 font-['Source_Serif_4']">Cores e nomes das editorias</p>
                  </div>
                  <button className="flex items-center gap-1.5 px-3 py-2 border border-[#111111] text-[10px] font-bold uppercase tracking-widest text-[#111111] hover:bg-[#111111] hover:text-white transition-all cursor-pointer whitespace-nowrap">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-add-line text-xs"></i>
                    </div>
                    Adicionar Seção
                  </button>
                </div>
                <div className="p-6">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b border-[#E0E0E0]">
                        <th className="pb-2 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Cor</th>
                        <th className="pb-2 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Seção</th>
                        <th className="pb-2 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Nome Editável</th>
                        <th className="pb-2 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Cor Hex</th>
                        <th className="pb-2 text-center text-[10px] font-bold uppercase tracking-widest text-[#555555]">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sectionColors.map((s, i) => (
                        <tr key={s.section} className={`border-b border-[#F0F0F0] ${i % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'}`}>
                          <td className="py-3 pr-4">
                            <div className="flex items-center gap-2">
                              <div className="w-5 h-5 border border-[#CCCCCC]" style={{ backgroundColor: s.color }}></div>
                              <input type="color" defaultValue={s.color} className="w-7 h-7 cursor-pointer border border-[#CCCCCC]" />
                            </div>
                          </td>
                          <td className="py-3 pr-4">
                            <span className="text-xs font-bold uppercase tracking-wide text-[#111111]">{s.section}</span>
                          </td>
                          <td className="py-3 pr-4">
                            <input
                              defaultValue={s.section}
                              className="w-32 px-2 py-1.5 text-xs border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']"
                            />
                          </td>
                          <td className="py-3 pr-4">
                            <input
                              defaultValue={s.color}
                              className="w-24 px-2 py-1.5 text-xs border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4'] uppercase"
                            />
                          </td>
                          <td className="py-3 text-center">
                            <button className="w-7 h-7 flex items-center justify-center mx-auto border border-[#E0E0E0] hover:border-[#C41230] hover:bg-[#C41230]/5 transition-all cursor-pointer">
                              <i className="ri-delete-bin-line text-[#C41230] text-sm"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* IA */}
            {activeTab === 'ia' && (
              <div className="bg-white border border-[#E0E0E0]">
                <div className="border-b-2 border-[#111111] px-6 py-3">
                  <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Configurações de IA</h2>
                  <p className="text-[11px] text-[#777777] mt-0.5 font-['Source_Serif_4']">Controle os módulos de inteligência artificial</p>
                </div>
                <div className="p-6 space-y-0">
                  {aiToggles.map((item, i) => (
                    <div key={i} className={`flex items-center justify-between px-4 py-4 border-b border-[#F0F0F0] ${i % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'}`}>
                      <div className="flex-1 pr-6">
                        <p className="text-xs font-bold uppercase tracking-wide text-[#111111]">{item.label}</p>
                        <p className="text-[11px] text-[#777777] font-['Source_Serif_4'] mt-0.5">{item.desc}</p>
                      </div>
                      <button
                        onClick={() => setToggles(prev => prev.map((v, idx) => idx === i ? !v : v))}
                        className={`w-12 h-6 border transition-all cursor-pointer relative flex-shrink-0 ${toggles[i] ? 'bg-[#111111] border-[#111111]' : 'bg-white border-[#CCCCCC]'}`}
                      >
                        <div className={`w-4 h-4 bg-white border absolute top-0.5 transition-all ${toggles[i] ? 'left-7 border-[#111111]' : 'left-0.5 border-[#CCCCCC]'}`}></div>
                      </button>
                    </div>
                  ))}
                  <div className="pt-5 space-y-4">
                    <div>
                      <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-2">Chave da API OpenAI</label>
                      <div className="flex gap-2">
                        <input
                          type="password"
                          defaultValue="sk-••••••••••••••••••••••••"
                          className="flex-1 px-3 py-2 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']"
                        />
                        <button className="px-4 py-2 border border-[#111111] text-[10px] font-bold uppercase tracking-widest text-[#111111] hover:bg-[#111111] hover:text-white transition-all cursor-pointer whitespace-nowrap">
                          Verificar
                        </button>
                      </div>
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-2">Modelo GPT</label>
                      <select className="w-full px-3 py-2 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] cursor-pointer bg-white font-['Source_Serif_4']">
                        <option>GPT-4o (Recomendado)</option>
                        <option>GPT-4 Turbo</option>
                        <option>GPT-3.5 Turbo</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* INTEGRAÇÕES */}
            {activeTab === 'integracao' && (
              <div className="bg-white border border-[#E0E0E0]">
                <div className="border-b-2 border-[#111111] px-6 py-3">
                  <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Integrações</h2>
                  <p className="text-[11px] text-[#777777] mt-0.5 font-['Source_Serif_4']">Serviços externos conectados ao sistema</p>
                </div>
                <div className="p-6 space-y-0">
                  {integrations.map((item, i) => (
                    <div key={i} className={`flex items-center gap-4 px-4 py-4 border-b border-[#F0F0F0] ${i % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'}`}>
                      <div className="w-10 h-10 border border-[#E0E0E0] bg-white flex items-center justify-center flex-shrink-0">
                        <i className={`${item.icon} text-lg ${item.status === 'conectado' ? 'text-[#111111]' : 'text-[#AAAAAA]'}`}></i>
                      </div>
                      <div className="flex-1">
                        <p className="text-xs font-bold uppercase tracking-wide text-[#111111]">{item.name}</p>
                        <p className="text-[11px] text-[#777777] font-['Source_Serif_4']">{item.desc}</p>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className={`text-[10px] font-bold uppercase tracking-widest px-2 py-1 border ${item.status === 'conectado' ? 'border-[#16A34A] text-[#16A34A] bg-[#16A34A]/5' : 'border-[#CCCCCC] text-[#888888]'}`}>
                          {item.status}
                        </span>
                        <button className={`px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest cursor-pointer whitespace-nowrap border transition-all ${item.status === 'conectado' ? 'border-[#CCCCCC] text-[#555555] hover:border-[#111111] hover:text-[#111111]' : 'bg-[#111111] text-white border-[#111111] hover:bg-[#333333]'}`}>
                          {item.status === 'conectado' ? 'Configurar' : 'Conectar'}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* USUÁRIOS */}
            {activeTab === 'usuarios' && (
              <div className="bg-white border border-[#E0E0E0]">
                <div className="border-b-2 border-[#111111] px-6 py-3 flex items-center justify-between">
                  <div>
                    <h2 className="font-['Playfair_Display'] text-base font-bold text-[#111111]">Usuários da Redação</h2>
                    <p className="text-[11px] text-[#777777] mt-0.5 font-['Source_Serif_4']">{users.length} membros cadastrados</p>
                  </div>
                  <button className="flex items-center gap-1.5 px-3 py-2 bg-[#111111] text-white text-[10px] font-bold uppercase tracking-widest hover:bg-[#333333] cursor-pointer whitespace-nowrap transition-all">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-user-add-line text-xs"></i>
                    </div>
                    Convidar
                  </button>
                </div>
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-[#E0E0E0] bg-[#F8F8F8]">
                      <th className="px-6 py-2.5 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Membro</th>
                      <th className="px-4 py-2.5 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">E-mail</th>
                      <th className="px-4 py-2.5 text-left text-[10px] font-bold uppercase tracking-widest text-[#555555]">Função</th>
                      <th className="px-4 py-2.5 text-center text-[10px] font-bold uppercase tracking-widest text-[#555555]">Status</th>
                      <th className="px-4 py-2.5 text-center text-[10px] font-bold uppercase tracking-widest text-[#555555]">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((u, i) => (
                      <tr key={i} className={`border-b border-[#F0F0F0] hover:bg-[#FAFAFA] transition-colors ${i % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'}`}>
                        <td className="px-6 py-3">
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 bg-[#111111] flex items-center justify-center flex-shrink-0">
                              <span className="text-[10px] font-bold text-white">{u.avatar}</span>
                            </div>
                            <span className="text-xs font-bold text-[#111111]">{u.name}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-[11px] text-[#555555] font-['Source_Serif_4']">{u.email}</td>
                        <td className="px-4 py-3">
                          <span className="text-[10px] font-bold uppercase tracking-wide border border-[#CCCCCC] px-2 py-0.5 text-[#555555]">{u.role}</span>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <div className="flex items-center justify-center gap-1.5">
                            <div className={`w-2 h-2 ${u.active ? 'bg-[#16A34A]' : 'bg-[#CCCCCC]'}`}></div>
                            <span className={`text-[10px] font-bold uppercase tracking-widest ${u.active ? 'text-[#16A34A]' : 'text-[#AAAAAA]'}`}>{u.active ? 'Ativo' : 'Inativo'}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <div className="flex items-center justify-center gap-1">
                            <button className="w-7 h-7 flex items-center justify-center border border-[#E0E0E0] hover:border-[#111111] hover:bg-[#111111] hover:text-white transition-all cursor-pointer group">
                              <i className="ri-edit-line text-[#555555] text-xs group-hover:text-white"></i>
                            </button>
                            <button className="w-7 h-7 flex items-center justify-center border border-[#E0E0E0] hover:border-[#C41230] hover:bg-[#C41230]/5 transition-all cursor-pointer">
                              <i className="ri-delete-bin-line text-[#C41230] text-xs"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
